import React, { Component, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Spinner,
  Button,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { getVideo } from '../../actions/VideoAction';
import { DELETE_VIDEO, GET_TOKEN } from 'utils';

import swal from 'sweetalert';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { logOutUser } from 'actions/AuthAction';

export default function ListVideo() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getListVideoError, getListVideoLoading, getListVideoResult } =
    useSelector((state) => state.VideoReducer);

  // auth

  const [token, setToken] = useState('');
  const [nama, setNama] = useState('');
  const [username, setUsername] = useState('');
  const [akses, setAkses] = useState('');
  const [expire, setExpire] = useState('');
  const [idAdmin, setIdAdmin] = useState('1');
  const [accessToken, setAccessToken] = useState('');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token');
      setToken(response.data);
      const decoded = jwt_decode(response.data.accessToken);
      setAccessToken(response.data.accessToken);
      setNama(decoded.nama);
      setUsername(decoded.username);
      setAkses(decoded.akses.split(','));
      setExpire(decoded.exp);
      setIdAdmin(decoded.idAdmin);
    } catch (error) {
      if (error.response) {
        dispatch(logOutUser(history));
        history.push('/');
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(GET_TOKEN + '/token');
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setNama(decoded.nama);
        setUsername(decoded.username);
        setAkses(decoded.akses);
        setIdAdmin(decoded.idAdmin);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //auth

  useEffect(() => {
    dispatch(getVideo());
    refreshToken();
  }, []);

  const removeData = async (id) => {
    try {
      await axios.delete(DELETE_VIDEO + `${id}`, {
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      swal('Sukses!', 'Video berhasil dihapus', 'success');
      history.push('/admin');
      history.push('/admin/video');
    } catch (error) {
      swal('Failed!', 'Forbiden', 'error');
    }
  };

  return (
    <div className='content'>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader>
              <CardTitle tag='h4'>List Video Youtube</CardTitle>
              <Link
                to={'/admin/video/tambah/' + idAdmin}
                className='btn btn-primary float-right'
              >
                Tambah Video
              </Link>
            </CardHeader>
            <CardBody style={{ overflowX: 'auto' }}>
              <Table>
                <thead className='text-primary'>
                  <tr>
                    <th>Id</th>
                    <th>Foto</th>
                    <th>Judul</th>
                    <th>Sumber</th>
                    <th>Tanggal</th>

                    <th>Link</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {getListVideoResult ? (
                    Object.keys(getListVideoResult).map((key) => (
                      <tr key={key}>
                        <td>{getListVideoResult[key].id}</td>
                        <td>
                          <img
                            src={getListVideoResult[key].gambar}
                            width='100'
                            alt={getListVideoResult[key].sumber}
                          />
                        </td>
                        <td>{getListVideoResult[key].judul}</td>
                        <td>{getListVideoResult[key].sumber}</td>
                        <td>{getListVideoResult[key].tanggal}</td>

                        <td>{getListVideoResult[key].link} </td>
                        <td>
                          <Link
                            className='btn btn-warning'
                            to={
                              '/admin/video/edit/' +
                              getListVideoResult[key].id +
                              ',' +
                              idAdmin
                            }
                          >
                            <i className='nc-icon nc-ruler-pencil'></i> Edit
                          </Link>
                        </td>
                        <td>
                          <Button
                            color='danger'
                            className='ml-2'
                            onClick={() =>
                              removeData(getListVideoResult[key].id)
                            }
                          >
                            <i className='nc-icon nc-basket'></i> Hapus
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : getListVideoLoading ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        <Spinner color='primary' />
                      </td>
                    </tr>
                  ) : getListVideoError ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        {getListVideoError}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Data Kosong
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
